<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- SMALL loader for form content -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    <div class="json-view-container">
      <pre class="old_new_view" [innerText]="requestJson"></pre>
    </div>
  </div>
}
  
</div>

<!-- STANDARD Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

